import React from 'react'
import { Button, Card } from 'react-bootstrap'

const RemoteOnboardingExecutiveTraining = () => {
  return (
    <>
        <Card className='text-center no-border rounded-0 industrial-modeling-top-section container'>
            <Card.Body>
                <Card.Title className='industrial-modeling-title'> リモートでの新人研修・人材育成 </Card.Title>
                <Card.Text className='industrial-environment-text text-left'>
                私たちの社会はリモート化しました。新入社員の入社式は、世界のどこでも、いつでも行われる可能性があります。VRとARは、ホログラム、バーチャル上の施設見学、そしてバーチャルな 職場体験を通じて、社員が会社や 指導者についての雰囲気をつかむのに役立ちます。
                </Card.Text>

                <Card.Subtitle className="industrial-modeling-subtitle pt-4"> リーダーシップ開発および幹部研修の事例 </Card.Subtitle>
                <Card.Text className='industrial-environment-text text-left'>
				あるクライアントでは、企業のシニアリーダー18人の経験から学ぶ「Leader Library」という2時間超のAR/VRコンテンツの制作に協力しました。
                </Card.Text>
                
            </Card.Body>
        </Card>
            <div className="onboard-slideshow d-none d-md-block">
				<div className="image-mover"></div>
			</div>


            <div className="mobile-onboard-slideshow d-sm-block d-md-none">
				<div className="mobile-image-mover"></div>
			</div>

			<Card className='no-border rounded-0 container py-md-4'>
			<Card.Title className='leadership-executive-bottom-title'> 研修や入社式は、楽しくインタラクティブに、そして臨場感あふれるものにしましょう。</Card.Title>
			<Button className='yellow-schedule-button shelterinplacevr-button btn btn-warning'> <a href="https://www.paracosma.com/jp/#contact-form" target="_blank" rel="noreferrer"> 相談予約 </a> </Button>
			</Card>
      
    </>
  )
}

export default RemoteOnboardingExecutiveTraining
